import gsap, { Expo, Linear, Power2, Power3 } from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';
import Keyboard from '../_app/cuchillo/core/Keyboard';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Header from '../layout/Header';
import IndexBar from '../layout/IndexBar';
import Default from './Default';
import { Ease } from '../_app/cuchillo/utils/Ease';
import { TitularMagneticController } from '../components/TitularMagneticReveal';
import { VerticalRevealText } from '../components/VerticalRevealText';

export default class Home extends Default {
  
//==================================================================================================================
//          CONSTRUCTOR
//==================================================================================================================

  constructor() {
    super();

    this.media = GetBy.class("__media", this.container)[0];
    this.holder = GetBy.selector("[data-holder-a]", this.container)[0];
    this.t1 = new VerticalRevealText(GetBy.selector("[data-text-a]")[0]);
    this.t2 = new VerticalRevealText(GetBy.selector("[data-text-b]")[0]);
    this.t3 = new VerticalRevealText(GetBy.selector("[data-text-c]")[0]);
    this.t4 = new VerticalRevealText(GetBy.selector("[data-text-d]")[0]);
    this.t5 = new VerticalRevealText(GetBy.selector("[data-text-e]")[0]);
    this.t6 = new VerticalRevealText(GetBy.selector("[data-text-f]")[0]);
    this.t7 = new VerticalRevealText(GetBy.selector("[data-text-g]")[0]);
  }

  afterShow() {
    super.afterShow();
    Scroll.start();

    let time = 0;
    let inc = 200;
    let inc2 = 700;
    let inc3 = 2500;
    let inc4 = 200;

    time = time + inc;
    setTimeout(()=> { this.t1.actual = 1; }, time);
    time = time + inc;
    setTimeout(()=> { this.t2.actual = 1; }, time);
    time = time + inc;
    setTimeout(()=> { this.t3.actual = 1; }, time);
    time = time + inc2;
    setTimeout(()=> { this.t3.actual = 2; }, time);
    time = time + inc2;
    setTimeout(()=> { this.t3.actual = 3; }, time);
    time = time + inc2;
    setTimeout(()=> {
      this.t3.actual = 4; }, time);
    setTimeout(()=> {
      this.t4.actual = 1;



      gsap.to(this.media,{opacity:1, duration:.1, delay:.2, onStart:()=> {Header.directShow();}, ease: Power2.easeIn});
    }, time);
    time = time + inc3;
    setTimeout(()=> { this.t1.actual = 2; }, time);
    setTimeout(()=> { this.t2.actual = 2; }, time);
    setTimeout(()=> { this.t3.actual = 5; }, time);
    setTimeout(()=> { 
      this.t4.actual = 2;
      gsap.to(this.holder,{opacity:0, duration:.1, delay:.3, ease: Power2.easeIn});
    }, time);
    time = time + inc4;
    setTimeout(()=> { 
     
      this.t5.actual = 1; }, time);
    time = time + inc;
    setTimeout(()=> { this.t6.actual = 1; }, time);
    time = time + inc;
    setTimeout(()=> { this.t7.actual = 1; }, time);

    time = time + 2000;
    setTimeout(()=> { if(Scroll.progress < 1) Scroll.goto(Metrics.HEIGHT); }, time);
  }

  //SHOW
  beforeShow() {
      super.beforeShow();
      //Scroll.init(Scroll.AXIS_Y, { domResize: this.container, smooth: !isTouch, multiplicator: 1 });
      Scroll.init();
      Keyboard.mountPage(this.id);
  
      if (this.isFirstTime) {
        Header.directHide();
        Scroll.stop();
        // Scene.init();
        // WebGLSketch.start();
      }
    }

  beforeHide() {
    super.beforeHide();
   
  }

  afterHide() {
    super.afterHide();
  }
}

ControllerPage._addPage("home", Home)
